/**
 * @file
 * Patria news listing select2.
 * Currently not in use.
 */

(function ($, Drupal) {

  'use strict';


  Drupal.behaviors.views_news_listing = {
    attach: function (context, settings) {

      // Hide Topic filter if empty
      if ($('#edit-topic').children().length == 0) {
        $('#edit-topic--wrapper').addClass('hide');
      }

      if ($('.views-news-listing-all').length) {

        // Init select2
        $('select[id^="edit-year"]').select2({
          minimumResultsForSearch: -1,
          placeholder: getDefaultText('year', '.js-form-item-year select'),
        });

        $('select[id^="edit-region"]').select2({
          minimumResultsForSearch: -1,
          placeholder: getDefaultText('region', '.js-form-item-region select'),
        });

        $('select[id^="edit-language"]').select2({
          minimumResultsForSearch: -1,
          placeholder: getDefaultText('language', '.js-form-item-language select'),
        });

        // Listen for changes
        $('select[id^="edit-year"]').on('change', function() {
          var selectedYear = $(this).val();
          var selectedRegion = getQueryVariable('region') ? getQueryVariable('region') : 'all';
          var selectedLanguage = getQueryVariable('language') ? getQueryVariable('language') : 'all';
          var selectedTopic = getAllTopic();
          refreshPageWithParameters(selectedRegion, selectedLanguage, selectedYear, selectedTopic);
        });

        $('select[id^="edit-region"]').on('change', function() {
          var selectedRegion = $(this).val();
          var selectedLanguage = getQueryVariable('language') ? getQueryVariable('language') : 'all';
          var selectedYear = getQueryVariable('year') ? getQueryVariable('year') : 'all';
          var selectedTopic = getAllTopic();
          refreshPageWithParameters(selectedRegion, selectedLanguage, selectedYear, selectedTopic);
        });

        $('select[id^="edit-language"]').on('change', function() {
          var selectedLanguage = $(this).val();
          var selectedRegion = getQueryVariable('region') ? getQueryVariable('region') : 'all';
          var selectedYear = getQueryVariable('year') ? getQueryVariable('year') : 'all';
          var selectedTopic = getAllTopic();
          refreshPageWithParameters(selectedRegion, selectedLanguage, selectedYear, selectedTopic);
        });

        $('#edit-topic').on('change', function() {
          var selectedTopic = getAllTopic();
          var selectedRegion = getQueryVariable('region') ? getQueryVariable('region') : 'all';
          var selectedLanguage = getQueryVariable('language') ? getQueryVariable('language') : 'all';
          var selectedYear = getQueryVariable('year') ? getQueryVariable('year') : 'all';
          refreshPageWithParameters(selectedRegion, selectedLanguage, selectedYear, selectedTopic);
        });

      }

      // Get all checked topics
      function getAllTopic() {
        var topics = $("#edit-topic input:checkbox:checked").map(function() {
          return $(this).val();
        }).get();
        if(topics.length == 0) {
          topics = ['all'];
        }
        return topics;
      }

      // Refresh page with query parameters added
      function refreshPageWithParameters(region, language, year, topic) {
        var url = document.location.origin;
        var path = $('html').attr('lang') == "fi" ? '/fi/media' : '/newsroom';
        url = url + path + "?region=" + region + "&language=" + language + "&year=" + year + "&topic=" + topic;
        window.location.href = url;
      }

      // Get the text value for the currently selected parameters
      function getDefaultText(paramter, target) {
        var queryVariable = getQueryVariable(paramter);

        // Return default values if no query parameter has been selected
        if (!queryVariable) {
          if (paramter == 'year') {
            return $('html').attr('lang') == "fi" ? 'Valitse' : 'Select';
          }
          if (paramter == 'region') {
            return $('html').attr('lang') == "fi" ? 'Valitse' : 'Select';
          }
          if (paramter == 'language') {
            return $('html').attr('lang') == "fi" ? 'Valitse' : 'Select';
          }
        }

        var defaultText  = $(target + " option[value='" + queryVariable + "']").text();
        return defaultText;
      }

      // Get query variables from the url by their key
      function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars  = query.split("&");

        for (var i = 0; i < vars.length; i++) {
         var pair = vars[i].split("=");
         if (pair[0] == variable) {
           return pair[1];
         }
        }
        return false;
      }

    }
  };

})(jQuery, Drupal);
